import { useState } from 'react';
import { GenericTable } from './GenericTable';
import { AddExerciseDialog } from '../../components/AddExerciseDialog';
import { exercisesColumns } from '../../constants/tableRows';
import { useExerciseByIdQuery } from '../../query/useExerciseByIdQuery';
import { useToastContext } from '../UI/ToastManager';

type RowData = Record<string, React.ReactNode>;

export function ExercisesTable({ onAdd, data }: { onAdd: () => void, data: RowData[] }) {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedExerciseId, setSelectedExerciseId] = useState<string | null>(null);
  const [dialogMode, setDialogMode] = useState<'add' | 'edit'>('add');
  const { showInfo } = useToastContext();

  // Fetch exercise data when editing
  const { data: exerciseData, isLoading: isLoadingExercise } = useExerciseByIdQuery(selectedExerciseId);

  const handleAddClick = () => {
    setSelectedExerciseId(null);
    setDialogMode('add');
    setDialogOpen(true);
  };

  const handleEditClick = (row: RowData) => {
    console.log('Edit button clicked, row data:', row);
    const exerciseId = row.id as string;
    console.log('Exercise ID:', exerciseId);
    if (!exerciseId) {
      showInfo('Error', 'Exercise ID not found');
      return;
    }
    setSelectedExerciseId(exerciseId);
    setDialogMode('edit');
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedExerciseId(null);
  };

  return (
    <>
      <GenericTable 
        columns={exercisesColumns} 
        data={data} 
        title='exercises' 
        onAdd={handleAddClick}
        onEdit={handleEditClick}
      />
      <AddExerciseDialog 
        open={isDialogOpen} 
        onOpenChange={handleDialogClose}
        exercise={exerciseData || null}
        mode={dialogMode}
      />
    </>
  );
}